import script from "./integration-payment-method-card.vue?vue&type=script&setup=true&lang=js"
export * from "./integration-payment-method-card.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__